// Wow animation
  new WOW().init();

$(document).ready(function() {
 
  $window = $(window);
  
  // Sticky menu
  $("nav.nav-bar").sticky({ topSpacing: 0 });
  
  // Parallax
  $('div[data-type="background"]').each(function(){
    var $bgobj = $(this);
    $(window).scroll(function() {

      var yPos = -($window.scrollTop() / $bgobj.data('speed')); 
      var coords = '50% '+ yPos + 'px';

      $bgobj.css({ backgroundPosition: coords });

    });
  });	
  
  // Owl carousel products carousel
  $(".product-carousel").owlCarousel({
    items : 4,
    itemsDesktop : [1000,4],
    itemsDesktopSmall : [960,3],
    itemsTablet: [748,2], 
    itemsMobile : [480,1],
    navigation: true,
    navigationText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>"
      ],
    pagination: false,
    autoPlay: false
  });
  
  // Owl sidebar products carousel
  $(".product-carousel-sidebar").owlCarousel({
    items : 1,
    itemsDesktop : [1000,1],
    itemsDesktopSmall : [960,1],
    itemsTablet: [748,1], 
    itemsMobile : [480,1],
    navigation: true,
    navigationText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>"
      ],
    pagination: false,
    autoPlay: false
  });
    
  
  // Owl carousel featured product carousel
  $(".featured-product-carousel").owlCarousel({
    items:1,
    itemsDesktop : [1000,1],
    itemsDesktopSmall : [960,1],
    itemsTablet: [748,1], 
    itemsMobile : [480,1],
    navigation: true,
    navigationText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>"
      ],
    pagination: false,
    autoPlay: true
  });
  
  // Accordion
  function close_accordion_section() {
    $('.accordion .accordion-section-title').removeClass('active');
    $('.accordion .accordion-section-content').slideUp(300).removeClass('open');
  }

  $('.accordion-section-title').click(function(e) {
    // Grab current anchor value
    var currentAttrValue = $(this).attr('href');

    if($(e.target).is('.active')) {
      close_accordion_section();
    }else {
      close_accordion_section();

      // Add active class to section title
      $(this).addClass('active');
      // Open up the hidden content panel
      $('.accordion ' + currentAttrValue).slideDown(300).addClass('open'); 
    }

    e.preventDefault();
  });
  
  // DOM Handlers 
  $(window).on('resize', function(){
    adjust_mega_menu();
    adjust_carousel_products_height();
    adjust_collection_products_details_height(); 
  });
  
  // On document load
  adjust_mega_menu();
  setTimeout(adjust_carousel_products_height,200);
  adjust_collection_products_details_height();
  
  
  
});


// Adjust carousel products height
adjust_carousel_products_height = function(){
  $('.product-carousel').each(function(){
  	
    var tallestItem = 0;
    
    $(this).find('.owl-item__image').each(function(i, val){
      tallestItem = $(val).height() > tallestItem ? $(val).height() : tallestItem;
    });
    
    $(this).find('.owl-item__image').each(function(i, val){
      $(val).height(tallestItem);
    });
    
  });
}

// Adjust collection products details height
adjust_collection_products_details_height = function(){
  var tallestItem = 0;
  $('.item-product__details').height('auto');
  $('.item-product__details').each(function(i, val){
    tallestItem = $(val).height() > tallestItem ? $(val).height() : tallestItem;
  });
  $('.item-product__details').each(function(i, val){
    $(val).height(tallestItem);
  }); 
}

// Adjust mega menu position
adjust_mega_menu = function(){
  $('.site-nav__mega-menu').css('left',( -1 *  $('.site-nav--has-megamenu').position().left) + 15);
  $('.site-nav__mega-menu').width( $('.top-bar').width()-40);
}

// Replace standar logo with retina version
